import axios from 'axios';

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error) return error.message;
  return fallback;
}

// Use for errors surfaced directly to the user. Prefers a server-provided message (sent as a
// plain string body) and otherwise returns the localized fallback. Unlike getErrorMessage, it
// never exposes an AxiosError's technical `.message` (e.g. "Request failed with status code 500").
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error) && typeof error.response?.data === 'string') {
    return error.response.data;
  }
  return fallback;
}
